export function computeStickVector(dxPx, dyPx, radius, deadzone) {
  const mag = Math.hypot(dxPx, dyPx);
  if (mag < deadzone) return { x: 0, y: 0 };
  const clamped = Math.min(mag, radius);
  const scale = clamped / radius / mag;   // unit-ish, clamped to [-1,1]
  return { x: dxPx * scale, y: dyPx * scale };
}

export function resolveMoveInput(kbDx, kbDy, stick) {
  if (kbDx !== 0 || kbDy !== 0) return { dx: kbDx, dy: kbDy };
  return { dx: stick.x, dy: stick.y };
}
